import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type DepartmentNodeFragment = { __typename?: 'Department', level?: Types.DepartmentLevel | null, key: string, title: string };

export type DepartmentTreeQueryVariables = Types.Exact<{
  roleId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type DepartmentTreeQuery = { __typename?: 'Query', departments: { __typename?: 'Departments', treeRestricted: Array<{ __typename?: 'Department', level?: Types.DepartmentLevel | null, key: string, title: string, children: Array<{ __typename?: 'Department', level?: Types.DepartmentLevel | null, key: string, title: string, children: Array<{ __typename?: 'Department', level?: Types.DepartmentLevel | null, key: string, title: string, children: Array<{ __typename?: 'Department', level?: Types.DepartmentLevel | null, key: string, title: string, children: Array<{ __typename?: 'Department', level?: Types.DepartmentLevel | null, key: string, title: string, children: Array<{ __typename?: 'Department', level?: Types.DepartmentLevel | null, key: string, title: string, children: Array<{ __typename?: 'Department', level?: Types.DepartmentLevel | null, key: string, title: string, children: Array<{ __typename?: 'Department', level?: Types.DepartmentLevel | null, key: string, title: string, children: Array<{ __typename?: 'Department', level?: Types.DepartmentLevel | null, key: string, title: string }> }> }> }> }> }> }> }> }> } };

export const DepartmentNodeFragmentDoc = gql`
    fragment DepartmentNode on Department {
  key: id
  title: name
  level
}
    `;
export const DepartmentTreeDocument = gql`
    query DepartmentTree($roleId: String) {
  departments {
    treeRestricted(roleId: $roleId) {
      ...DepartmentNode
      children {
        ...DepartmentNode
        children {
          ...DepartmentNode
          children {
            ...DepartmentNode
            children {
              ...DepartmentNode
              children {
                ...DepartmentNode
                children {
                  ...DepartmentNode
                  children {
                    ...DepartmentNode
                    children {
                      ...DepartmentNode
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DepartmentNodeFragmentDoc}`;

/**
 * __useDepartmentTreeQuery__
 *
 * To run a query within a React component, call `useDepartmentTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentTreeQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDepartmentTreeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DepartmentTreeQuery, DepartmentTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DepartmentTreeQuery, DepartmentTreeQueryVariables>(DepartmentTreeDocument, options);
      }
export function useDepartmentTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DepartmentTreeQuery, DepartmentTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DepartmentTreeQuery, DepartmentTreeQueryVariables>(DepartmentTreeDocument, options);
        }
// @ts-ignore
export function useDepartmentTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DepartmentTreeQuery, DepartmentTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentTreeQuery, DepartmentTreeQueryVariables>;
export function useDepartmentTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentTreeQuery, DepartmentTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DepartmentTreeQuery | undefined, DepartmentTreeQueryVariables>;
export function useDepartmentTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DepartmentTreeQuery, DepartmentTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DepartmentTreeQuery, DepartmentTreeQueryVariables>(DepartmentTreeDocument, options);
        }
export type DepartmentTreeQueryHookResult = ReturnType<typeof useDepartmentTreeQuery>;
export type DepartmentTreeLazyQueryHookResult = ReturnType<typeof useDepartmentTreeLazyQuery>;
export type DepartmentTreeSuspenseQueryHookResult = ReturnType<typeof useDepartmentTreeSuspenseQuery>;
export type DepartmentTreeQueryResult = Apollo.QueryResult<DepartmentTreeQuery, DepartmentTreeQueryVariables>;